import { memo, useContext, useMemo, useState } from "react";
import UseFetch from "hooks/useFetch";
import contentStatuses from "constants/content-statuses";
import moment from "jalali-moment";
import InitializeContext from "context/initialize-context";
import ChartLine from "../../shared/charts/line";
import ChartBoxSkeleton from "components/skeleton/chart-box";
import TinyListSkeleton from "components/skeleton/tiny-list";
import GoToAll from "components/shared/go-to-all";

const Content = props => {
    const { fetchUrl } = props;
    const { data, isLoading, error } = UseFetch(fetchUrl);
    const enums = useContext(InitializeContext);
    const [activeForm, setActiveForm] = useState(enums.data.forms[0]?.id || "");

    const statuses = useMemo(() => {
        return enums.data.forms.map(form => ({
            title: form.title,
            value: form.id
        }));
        // eslint-disable-next-line
    }, [])

    const chartData = useMemo(() => {
        const counts = [];
        const days = [];

        if (!isLoading && !error && data.data.new_content_graph_last_month[activeForm])
            data.data.new_content_graph_last_month[activeForm].forEach(el => {
                counts.push(el.count);
                days.push(moment.unix(el.day).format("jYYYY/jMM/jD"));
            })

        return {
            counts,
            days
        }
    }, [isLoading, data, error, activeForm])

    const activeFormLabel = useMemo(() => {
        const intendedForm = enums.data.forms.find(form => form.id === parseInt(activeForm));
        return intendedForm ? intendedForm.title : "";
        // eslint-disable-next-line
    }, [activeForm])

    if (enums.data.forms.length === 0)
        return <></>;

    return (
        <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-full lg:col-span-8">
                {
                    !isLoading ? (
                        !error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <h2 className="tp-34 text-sm font-bold pb-4">نمودار ایجاد محتویات</h2>

                                <div className="pt-3">
                                    <label className="select-c1 mb-8">
                                        <span>فرم انتخاب شده</span>

                                        <select onChange={e => setActiveForm(e.target.value)} value={activeForm}>
                                            {
                                                statuses.map(status => (
                                                    <option key={`option-${status.value}`} value={status.value}>{status.title}</option>
                                                ))
                                            }
                                        </select>
                                    </label>

                                    <ChartLine series={[{ name: 'تعداد', data: chartData.counts }]} xaxis={chartData.days} />
                                </div>
                            </div>
                        ) : <p className="text-red-500 text-xs">خطای سیستم!</p>
                    ) : <ChartBoxSkeleton />
                }
            </div>

            <div className="col-span-full lg:col-span-4">
                {
                    !isLoading ? (
                        !error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <div className="state-box h-full flex flex-col">
                                    <div className="flex mb-4 items-center justify-between reset-i">
                                        <h2 className="title tp-34">وضعیت محتویات ({activeFormLabel})</h2>
                                        <GoToAll link={`/panel/content?form_id=${activeForm}`} />
                                    </div>

                                    <div className="overflow-auto spec-sb-c2">
                                        <ul>
                                            {
                                                contentStatuses.map((status, i) => (
                                                    <li key={`content-status-${i}`}>
                                                        <div>
                                                            <span className="sec-title tp-34">{status.title}</span>
                                                        </div>

                                                        <b className="tp-34">
                                                            {data.data.content_status[activeForm] ? data.data.content_status[activeForm][i] || 0 : 0}
                                                        </b>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : <p className="text-red-500 text-xs">خطای سیستم!</p>
                    ) : <TinyListSkeleton />
                }
            </div>
        </div>
    )
}

export default memo(Content);